module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/long-brown-hair-red/long-brown-hair-red@1x.png"